import { mockData } from '../services/mockData'
import { practicesStore } from '../services/practicesStore'
import { requesterName } from './practices'
import { Practice, PracticeDraft } from '../types/practice'

export type EmailRecipientRole = 'Cliente' | 'Azienda' | 'Email Formazione'

export interface EmailRecipient {
  role: EmailRecipientRole
  email: string
}

// Recipients of a practice email: the client, the company and the
// "Email Formazione" address registered in the company registry
export function practiceRecipients(p: PracticeDraft): EmailRecipient[] {
  const list: EmailRecipient[] = []
  if (p.clientEmail?.trim())
    list.push({ role: 'Cliente', email: p.clientEmail.trim() })
  if (p.clientType === 'anagrafica' && p.companyName) {
    const company = mockData.getClientByName(p.companyName)
    if (company?.email) list.push({ role: 'Azienda', email: company.email })
    if (company?.trainingEmail)
      list.push({ role: 'Email Formazione', email: company.trainingEmail })
  }
  // The same address is sent only once
  return list.filter(
    (r, i) => list.findIndex((x) => x.email === r.email) === i,
  )
}

export function recipientGroups(list: Practice[]) {
  return list.map((p) => ({
    id: p.id,
    name: requesterName(p),
    recipients: practiceRecipients(p),
  }))
}

// Simulated send: records the email in each practice history
export function sendPracticeEmail(list: Practice[], body: string) {
  const recipients: Record<string, string[]> = {}
  list.forEach((p) => {
    recipients[p.id] = practiceRecipients(p).map((r) => r.email)
  })
  practicesStore.logEmail(
    list.filter((p) => recipients[p.id].length > 0).map((p) => p.id),
    recipients,
    body,
  )
}
